<template>
  <div>
    <div class="coming_soon_wrap div_zindex white-text">

      <section class="coming_soon_content">
        <div class="container">
          <div class="row">
            <div class="col-md-5">
              <br /><br />
              <h1>This business has ceased operations</h1>
            </div>
          </div>
        </div>
      </section>

    </div>
    <div class="coming_soon_bg">
      <div class="dark-overlay"></div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'BusinessClosed',
  computed: {
    currentYear() {
      return moment().format('yyyy')
    }
  }
}
</script>

<style scoped>
</style>